/* eslint-disable no-restricted-globals */
import styles from './sixth.module.css';
import FullSize from '../../components/full-size';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AnswerForm from '../../components/answer-form';
import {
  getNextLevelUrl,
  isLevelAllowed,
  markLevelCompleted,
} from '../../helper';
import HintBox from '../../components/hint-box';

const CORRECT_CODE = ['up', 'up', 'down', 'down', 'left', 'right', 'left', 'right', 'b', 'a'];

type Button = 'up' | 'down' | 'left' | 'right' | 'options' | 'start' | 'a' | 'b';

function Sixth() {
  const LEVEL = 6;
  const navigate = useNavigate();
  const [sequence, setSequence] = useState<Button[]>([]);
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate('/cheating');
    }
  }, [navigate]);

  const handleButtonClick = (button: Button, event: React.MouseEvent<HTMLDivElement>) => {
    // Add visual feedback
    const target = event.currentTarget;
    target.classList.add(styles.pressed);
    setTimeout(() => {
      target.classList.remove(styles.pressed);
    }, 150);

    setSequence((prev) => {
      const newSequence = [...prev, button];
      // Keep max 10 items, remove oldest if exceeding
      if (newSequence.length > 10) {
        return newSequence.slice(1);
      }
      return newSequence;
    });
  };

  const handleFormSubmit = (answer: string) => {
    if (answer === '0473' || answer === '04473' || answer === '9898') {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setShake(true);
    }
  };

  useEffect(() => {
    // Check if sequence matches the code
    if (sequence.length === 10 && 
        sequence.every((btn, index) => btn === CORRECT_CODE[index])) {
      // Open YouTube video in new tab
      window.open('https://youtu.be/fwQuknkLNEc', '_blank');
    }
  }, [sequence, navigate]);

  return (
    <FullSize bgColor="black">
      <div className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          <div className={styles.title}>Level 6</div>
          <div className={styles.formWrapper}>
            <AnswerForm 
              type="number" 
              onSubmit={handleFormSubmit} 
              shake={shake} 
              setShake={setShake} 
            />
          </div>
          <p className={styles.subtitle}>Konami</p>
          
          <div 
            className={`${styles.button} ${styles.up}`}
            onClick={(e) => handleButtonClick('up', e)}
          />
          <div 
            className={`${styles.button} ${styles.down}`}
            onClick={(e) => handleButtonClick('down', e)}
          />
          <div 
            className={`${styles.button} ${styles.left}`}
            onClick={(e) => handleButtonClick('left', e)}
          />
          <div 
            className={`${styles.button} ${styles.right}`}
            onClick={(e) => handleButtonClick('right', e)}
          />
          
          {/* A and B buttons */}
          <div 
            className={`${styles.button} ${styles.a}`}
            onClick={(e) => handleButtonClick('a', e)}
          />
          <div 
            className={`${styles.button} ${styles.b}`}
            onClick={(e) => handleButtonClick('b', e)}
          />
          
          {/* Start and Select */}
          <div 
            className={`${styles.button} ${styles.start}`}
            onClick={(e) => handleButtonClick('start', e)}
          />
          <div 
            className={`${styles.button} ${styles.options}`}
            onClick={(e) => handleButtonClick('options', e)}
          />
        </div>
        
        {/* Display sequence */}
        {/* {sequence.length > 0 && (
          <div className={styles.sequence}>
            {sequence.map((btn, index) => (
              <span key={index} className={styles.sequenceItem}>
                {btn === 'up' && '↑'}
                {btn === 'down' && '↓'}
                {btn === 'left' && '‹'}
                {btn === 'right' && '›'}
                {btn === 'start' && 'START'}
                {btn === 'options' && 'OPTIONS'}
                {btn === 'a' && 'A'}
                {btn === 'b' && 'B'}
              </span>
            ))}
          </div>
        )} */}
      </div>
      <HintBox hintText="Konami cheat code. Google it om du är noob." />
    </FullSize>
  );
}

export default Sixth;